/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Constant definitions
 */

export const BERLIN_TENANT_ID_HEADER = 'x-berlin-tenant-id';
export const BERLIN_API_V1_VERSION = 'api/1.0';
export const BERLIN_API_TIMEOUT = 60000;
export const EVG_V1_VERSION = 'api/v1';

/** Query params for GET aiadmin tenant providers filtered to audio-capable entries */
export const AUDIO_PROVIDERS_QUERY_PARAMS = { audio: true };

export const GET_TENANT_LIST = 'GET_TENANT_LIST';
export const GET_TENANT_LIST_SUCCESS = 'GET_TENANT_LIST_SUCCESS';

export const GET_TENANT_PROVIDER_LIST = 'GET_TENANT_PROVIDER_LIST';
export const GET_TENANT_PROVIDER_SUCCESS = 'GET_TENANT_PROVIDER_SUCCESS';
export const GET_TENANT_AUDIO_PROVIDERS_SUCCESS = 'GET_TENANT_AUDIO_PROVIDERS_SUCCESS';
export const GET_TENANT_AUDIO_PROVIDERS_ERROR = 'GET_TENANT_AUDIO_PROVIDERS_ERROR';
export const GET_TENANT_LIST_STATUS = 'GET_TENANT_LIST_STATUS';
export const FILTER_TYPE = 'FILTER_TYPE';

// Graphs
export const GET_GRAPHS_LIST = 'GET_GRAPHS_LIST';
export const GET_GRAPHS_LIST_RESPONSE = 'GET_GRAPHS_LIST_RESPONSE';
export const GET_GRAPHS_LIST_STATUS = 'graphsListStatus';
export const GRAPHS_LIST_ENDPOINT = '/graphs';
// Token Operations (Studio)
export const GET_SYS2SYS_TOKEN = 'GET_SYS2SYS_TOKEN';
export const GET_SYS2SYS_TOKEN_SUCCESS = 'GET_SYS2SYS_TOKEN_SUCCESS';
export const GET_SYS2SYS_TOKEN_ERROR = 'GET_SYS2SYS_TOKEN_ERROR';

export const GET_CDN_TOKEN = 'GET_CDN_TOKEN';
export const GET_CDN_TOKEN_SUCCESS = 'GET_CDN_TOKEN_SUCCESS';
export const GET_CDN_TOKEN_ERROR = 'GET_CDN_TOKEN_ERROR';

export const DELETE_GRAPH = 'DELETE_GRAPH';
export const DELETE_GRAPH_SUCCESS = 'DELETE_GRAPH_SUCCESS';
export const DELETE_GRAPH_ERROR = 'DELETE_GRAPH_ERROR';

export const UPDATE_GRAPH_TITLE = 'UPDATE_GRAPH_TITLE';
export const UPDATE_GRAPH_TITLE_SUCCESS = 'UPDATE_GRAPH_TITLE_SUCCESS';
export const UPDATE_GRAPH_TITLE_ERROR = 'UPDATE_GRAPH_TITLE_ERROR';

export const SHARE_GRAPH = 'SHARE_GRAPH';
export const SHARE_GRAPH_SUCCESS = 'SHARE_GRAPH_SUCCESS';
export const SHARE_GRAPH_ERROR = 'SHARE_GRAPH_ERROR';

export const UPDATE_GRAPH_ACCESS = 'UPDATE_GRAPH_ACCESS';
export const UPDATE_GRAPH_ACCESS_SUCCESS = 'UPDATE_GRAPH_ACCESS_SUCCESS';
export const UPDATE_GRAPH_ACCESS_ERROR = 'UPDATE_GRAPH_ACCESS_ERROR';

export const GET_GRAPH_ACCESS = 'GET_GRAPH_ACCESS';
export const GET_GRAPH_ACCESS_SUCCESS = 'GET_GRAPH_ACCESS_SUCCESS';
export const GET_GRAPH_ACCESS_ERROR = 'GET_GRAPH_ACCESS_ERROR';

export const REVOKE_GRAPH_ACCESS = 'REVOKE_GRAPH_ACCESS';
export const REVOKE_GRAPH_ACCESS_SUCCESS = 'REVOKE_GRAPH_ACCESS_SUCCESS';
export const REVOKE_GRAPH_ACCESS_ERROR = 'REVOKE_GRAPH_ACCESS_ERROR';

// Graph Params
export const GET_GRAPH_PARAMS = 'GET_GRAPH_PARAMS';
export const GET_GRAPH_PARAMS_SUCCESS = 'GET_GRAPH_PARAMS_SUCCESS';
export const GET_GRAPH_PARAMS_ERROR = 'GET_GRAPH_PARAMS_ERROR';

export const SAVE_GRAPH_PARAMS = 'SAVE_GRAPH_PARAMS';
export const SAVE_GRAPH_PARAMS_SUCCESS = 'SAVE_GRAPH_PARAMS_SUCCESS';
export const SAVE_GRAPH_PARAMS_ERROR = 'SAVE_GRAPH_PARAMS_ERROR';

export const DELETE_GRAPH_PARAMS = 'DELETE_GRAPH_PARAMS';
export const DELETE_GRAPH_PARAMS_SUCCESS = 'DELETE_GRAPH_PARAMS_SUCCESS';
export const DELETE_GRAPH_PARAMS_ERROR = 'DELETE_GRAPH_PARAMS_ERROR';

// Graph Operations - Load
export const GET_GRAPH = 'GET_GRAPH';
export const GET_GRAPH_SUCCESS = 'GET_GRAPH_SUCCESS';
export const GET_GRAPH_ERROR = 'GET_GRAPH_ERROR';

// Feature config — GET /api/1.0/feature/config/fetch (Berlin API version, not aiadmin /api/v1)
export const GET_FEATURE_CONFIG = 'GET_FEATURE_CONFIG';
export const FEATURE_CONFIG_FETCH_ENDPOINT = `/${BERLIN_API_V1_VERSION}/feature/config/fetch`;

// Graph Operations - Create (POST /graphs)
export const CREATE_GRAPH = 'CREATE_GRAPH';
export const CREATE_GRAPH_SUCCESS = 'CREATE_GRAPH_SUCCESS';
export const CREATE_GRAPH_ERROR = 'CREATE_GRAPH_ERROR';

// Graph Operations - Update (PUT /graphs/:graphId)
export const UPDATE_GRAPH = 'UPDATE_GRAPH';
export const UPDATE_GRAPH_SUCCESS = 'UPDATE_GRAPH_SUCCESS';
export const UPDATE_GRAPH_ERROR = 'UPDATE_GRAPH_ERROR';
export const UPDATE_GRAPH_CONFLICT = 'UPDATE_GRAPH_CONFLICT';
export const UPDATE_GRAPH_PUBLISHED_DURING_EDIT = 'UPDATE_GRAPH_PUBLISHED_DURING_EDIT';

// Graph Evaluation - List (GET /graphs/:graphId/evaluations?version=)
export const GET_GRAPH_EVALUATIONS = 'GET_GRAPH_EVALUATIONS';
export const GET_GRAPH_EVALUATIONS_SUCCESS = 'GET_GRAPH_EVALUATIONS_SUCCESS';
export const GET_GRAPH_EVALUATIONS_ERROR = 'GET_GRAPH_EVALUATIONS_ERROR';

export const GET_GRAPH_EVALUATION_DETAIL = 'GET_GRAPH_EVALUATION_DETAIL';
export const GET_GRAPH_EVALUATION_DETAIL_SUCCESS = 'GET_GRAPH_EVALUATION_DETAIL_SUCCESS';
export const GET_GRAPH_EVALUATION_DETAIL_ERROR = 'GET_GRAPH_EVALUATION_DETAIL_ERROR';

// Graph Evaluation - Create (POST /graphs/:graphId/evaluations?version=)
export const CREATE_EVALUATION = 'CREATE_EVALUATION';
export const CREATE_EVALUATION_SUCCESS = 'CREATE_EVALUATION_SUCCESS';
export const CREATE_EVALUATION_ERROR = 'CREATE_EVALUATION_ERROR';

// Graph Evaluation - Delete (DELETE /graphs/:graphId/eval/:rubricId)
export const DELETE_EVALUATION = 'DELETE_EVALUATION';
export const DELETE_EVALUATION_SUCCESS = 'DELETE_EVALUATION_SUCCESS';
export const DELETE_EVALUATION_ERROR = 'DELETE_EVALUATION_ERROR';

// Graph Evaluation - Save rubric text (PUT /graphs/:graphId/eval/:rubricId/rubrictext)
export const SAVE_EVALUATION_RUBRIC_TEXT = 'SAVE_EVALUATION_RUBRIC_TEXT';
export const SAVE_EVALUATION_RUBRIC_TEXT_SUCCESS = 'SAVE_EVALUATION_RUBRIC_TEXT_SUCCESS';
export const SAVE_EVALUATION_RUBRIC_TEXT_ERROR = 'SAVE_EVALUATION_RUBRIC_TEXT_ERROR';

// Graph Evaluation - Save scheduler (PUT /graphs/:graphId/eval/:rubricId/scheduler)
export const SAVE_EVALUATION_SCHEDULER = 'SAVE_EVALUATION_SCHEDULER';
export const SAVE_EVALUATION_SCHEDULER_SUCCESS = 'SAVE_EVALUATION_SCHEDULER_SUCCESS';
export const SAVE_EVALUATION_SCHEDULER_ERROR = 'SAVE_EVALUATION_SCHEDULER_ERROR';

// Graph Evaluation - Run eval lens (POST /graphs/run-eval-lens)
export const POST_RUN_EVAL_LENS_CRITERIA_RUN_NOW = 'POST_RUN_EVAL_LENS_CRITERIA_RUN_NOW';
export const POST_RUN_EVAL_LENS_CRITERIA_RUN_NOW_SUCCESS = 'POST_RUN_EVAL_LENS_CRITERIA_RUN_NOW_SUCCESS';
export const POST_RUN_EVAL_LENS_CRITERIA_RUN_NOW_ERROR = 'POST_RUN_EVAL_LENS_CRITERIA_RUN_NOW_ERROR';

// Graph Evaluation - Run eval lens (POST /evaluation) — Graph Tester
export const POST_RUN_EVAL_LENS_EVALUATION = 'POST_RUN_EVAL_LENS_EVALUATION';
export const POST_RUN_EVAL_LENS_EVALUATION_SUCCESS = 'POST_RUN_EVAL_LENS_EVALUATION_SUCCESS';
export const POST_RUN_EVAL_LENS_EVALUATION_ERROR = 'POST_RUN_EVAL_LENS_EVALUATION_ERROR';

// Graph Operations - Create Version (POST /graphs/:graphId/versions)
export const CREATE_GRAPH_VERSION = 'CREATE_GRAPH_VERSION';
export const CREATE_GRAPH_VERSION_SUCCESS = 'CREATE_GRAPH_VERSION_SUCCESS';
export const CREATE_GRAPH_VERSION_ERROR = 'CREATE_GRAPH_VERSION_ERROR';

// Graph Operations - Publish (PUT /graphs/:graphId/publish)
export const PUBLISH_GRAPH = 'PUBLISH_GRAPH';
export const PUBLISH_GRAPH_SUCCESS = 'PUBLISH_GRAPH_SUCCESS';
export const PUBLISH_GRAPH_ERROR = 'PUBLISH_GRAPH_ERROR';
export const PUBLISH_GRAPH_CONFLICT = 'PUBLISH_GRAPH_CONFLICT';

// Graph Operations - Copy (POST /graphs/copy)
export const COPY_GRAPH = 'COPY_GRAPH';
export const COPY_GRAPH_SUCCESS = 'COPY_GRAPH_SUCCESS';
export const COPY_GRAPH_ERROR = 'COPY_GRAPH_ERROR';

// Graph Operations - Promote (POST /graphs/:graphId/promote)
export const PROMOTE_GRAPH = 'PROMOTE_GRAPH';
export const PROMOTE_GRAPH_SUCCESS = 'PROMOTE_GRAPH_SUCCESS';
export const PROMOTE_GRAPH_ERROR = 'PROMOTE_GRAPH_ERROR';

// Graph Operations - Set Default Version (PATCH /graphs)
export const SET_GRAPH_DEFAULT = 'SET_GRAPH_DEFAULT';
export const SET_GRAPH_DEFAULT_SUCCESS = 'SET_GRAPH_DEFAULT_SUCCESS';
export const SET_GRAPH_DEFAULT_ERROR = 'SET_GRAPH_DEFAULT_ERROR';

// Graph Tester - Execution Logs
export const GET_EXECUTION_LOGS = 'GET_EXECUTION_LOGS';
export const GET_EXECUTION_LOGS_SUCCESS = 'GET_EXECUTION_LOGS_SUCCESS';
export const GET_EXECUTION_LOGS_ERROR = 'GET_EXECUTION_LOGS_ERROR';
export const EXECUTION_LOGS_AUDIT_FALLBACK_QUERY = 'auditFallback=true';
export const EXECUTION_LOGS_SOURCE_AUDIT = 'audit';
export const EXECUTION_LOGS_ERROR_NOT_FOUND = 'NOT_FOUND';
export const EXECUTION_LOGS_ERROR_FETCH_FAILED = 'FETCH_FAILED';

// Graph Tester - LLM Logs
export const GET_LLM_LOGS = 'GET_LLM_LOGS';
export const GET_LLM_LOGS_SUCCESS = 'GET_LLM_LOGS_SUCCESS';
export const GET_LLM_LOGS_ERROR = 'GET_LLM_LOGS_ERROR';
// Graph List
export const GET_GRAPHS = 'GET_GRAPHS';
export const GET_GRAPHS_SUCCESS = 'GET_GRAPHS_SUCCESS';
export const GET_GRAPHS_ERROR = 'GET_GRAPHS_ERROR';

// Graph Code
export const GET_GRAPH_CODE = 'GET_GRAPH_CODE';
export const GET_GRAPH_CODE_SUCCESS = 'GET_GRAPH_CODE_SUCCESS';
export const GET_GRAPH_CODE_ERROR = 'GET_GRAPH_CODE_ERROR';

// Agentic Tools (GET /graphs/tools)
export const GET_AGENTIC_TOOLS = 'GET_AGENTIC_TOOLS';
export const GET_AGENTIC_TOOLS_SUCCESS = 'GET_AGENTIC_TOOLS_SUCCESS';
export const GET_AGENTIC_TOOLS_ERROR = 'GET_AGENTIC_TOOLS_ERROR';

// Graph History Compare (GET /graphs/:graphId for history comparison)
export const GET_GRAPH_FOR_HISTORY = 'GET_GRAPH_FOR_HISTORY';
export const GET_GRAPH_FOR_HISTORY_SUCCESS = 'GET_GRAPH_FOR_HISTORY_SUCCESS';
export const GET_GRAPH_FOR_HISTORY_ERROR = 'GET_GRAPH_FOR_HISTORY_ERROR';

// Graph History List (GET /graphs/:graphId/history)
export const GET_GRAPH_HISTORY = 'GET_GRAPH_HISTORY';
export const GET_GRAPH_HISTORY_SUCCESS = 'GET_GRAPH_HISTORY_SUCCESS';
export const GET_GRAPH_HISTORY_ERROR = 'GET_GRAPH_HISTORY_ERROR';

// Graph By Object ID (GET /graphs/history/:objectId)
export const GET_GRAPH_BY_OBJECT_ID = 'GET_GRAPH_BY_OBJECT_ID';
export const GET_GRAPH_BY_OBJECT_ID_SUCCESS = 'GET_GRAPH_BY_OBJECT_ID_SUCCESS';
export const GET_GRAPH_BY_OBJECT_ID_ERROR = 'GET_GRAPH_BY_OBJECT_ID_ERROR';

// Target Tenants (GET /tenants/:env)
export const GET_TARGET_TENANTS = 'GET_TARGET_TENANTS';

// Model Properties Mapping
export const GET_MODEL_PROPERTIES = 'GET_MODEL_PROPERTIES';
export const GET_MODEL_PROPERTIES_SUCCESS = 'GET_MODEL_PROPERTIES_SUCCESS';
export const GET_MODEL_PROPERTIES_ERROR = 'GET_MODEL_PROPERTIES_ERROR';

export const MCP_API_BASE_PATH = '/api/1.0/mcp';
export const MIDDLEWARE_CONFIGS_ENDPOINT = '/middleware-configs';
// Content Upload (POST /api/v2.0/upload)
export const UPLOAD_CONTENT = 'UPLOAD_CONTENT';
export const UPLOAD_CONTENT_SUCCESS = 'UPLOAD_CONTENT_SUCCESS';
export const UPLOAD_CONTENT_ERROR = 'UPLOAD_CONTENT_ERROR';

// Get Uploaded Content (GET /api/v2.0/upload/content)
export const GET_UPLOADED_CONTENT = 'GET_UPLOADED_CONTENT';
export const GET_UPLOADED_CONTENT_SUCCESS = 'GET_UPLOADED_CONTENT_SUCCESS';
export const GET_UPLOADED_CONTENT_ERROR = 'GET_UPLOADED_CONTENT_ERROR';

// Delete Uploaded Content (POST /api/v2.0/upload/content/:fileId)
export const DELETE_CONTENT = 'DELETE_CONTENT';
export const DELETE_CONTENT_SUCCESS = 'DELETE_CONTENT_SUCCESS';
export const DELETE_CONTENT_ERROR = 'DELETE_CONTENT_ERROR';

// Content item status values (matches backend API)
export const CONTENT_STATUS_PROCESSING = 'PROCESSING';
export const CONTENT_STATUS_READY = 'READY';
export const CONTENT_STATUS_FAILED = 'FAILED';

// Prompt v2 (Studio agent-modal hydration — versions list only; writes on graph save)
export const GET_PROMPT_VERSIONS = 'GET_PROMPT_VERSIONS';
export const GET_PROMPT_VERSIONS_SUCCESS = 'GET_PROMPT_VERSIONS_SUCCESS';
export const GET_PROMPT_VERSIONS_ERROR = 'GET_PROMPT_VERSIONS_ERROR';
